<template>
  <section class="about__area pt-90 pb-150">
    <div class="container">
      <div class="row">
        <div class="col-12 mb-50 text-center">
          <h2 class="section__title" style="font-size: 30px; text-transform: uppercase">{{$t('about.raqam')}}</h2>
        </div>
      </div>
      <div class="row mb-50">
        <div class="col-lg-8 col-12">
          <div class="about__content pl-10 pr-10 pt-25">
            <div class="about__list mb-35"><p style="list-style-type: disc; font-size: 16px; font-weight: 500; color: #0e1133;">{{$t('about.raqam1')}}</p></div>
          </div>
        </div>
        <div class="col-lg-4 col-12">
          <div class="about__thumb-wrapper">
            <div class="about__thumb">
              <img src="../../assets/img/raqam6.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-12">
          <div class="about__thumb-wrapper">
            <div class="about__thumb pt-50">
              <img src="../../assets/img/raqam5.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-12">
          <div class="about__content pl-10 pr-10 pt-10">
            <div class="section__title-wrapper mb-25">
              <h2 class="section__title" style="font-size: 26px">{{$t('about.raqam2')}}</h2>
            </div>
            <div class="about__list mb-35">
              <h4>{{$t('about.raqam3')}}</h4>
              <ul>
                <li><i class="icon_check"></i>{{$t('about.raqam4')}}</li>
                <li><i class="icon_check"></i>{{$t('about.raqam5')}}</li>
              </ul>
              <h4>{{$t('about.raqam6')}}</h4>
              <ul>
                <li><i class="icon_check"></i>{{$t('about.raqam7')}}</li>
                <li><i class="icon_check"></i>{{$t('about.raqam8')}}</li>
              </ul>
              <h4>{{$t('about.raqam9')}}</h4>
              <ul>
                <li><i class="icon_check"></i>{{$t('about.raqam10')}}</li>
                <li><i class="icon_check"></i>{{$t('about.raqam11')}}</li>
              </ul>
              <h4>{{$t('about.raqam12')}}</h4>
              <ul>
                <li><i class="icon_check"></i>{{$t('about.raqam13')}}</li>
                <li><i class="icon_check"></i>{{$t('about.raqam14')}}</li>
              </ul>
              <h4>{{$t('about.raqam15')}}</h4>
              <ul>
                <li><i class="icon_check"></i>{{$t('about.raqam16')}}</li>
                <li><i class="icon_check"></i>{{$t('about.raqam17')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name:'RaqamArea'
};
</script>
